<template>
  <div>
    <el-dialog
      class="theme-dialog dialog-center dialog-body-0"
      :title="title"
      width="975px"
      top="0"
      :center="true"
      :close-on-click-modal="false"
      :visible.sync="visibility"
    >
      <div class="w-full max-h-650px px-6 py-4 box-border bg-card-bg-gray overflow-auto" v-loading="loading">
        <el-timeline class="step_container">
          <el-timeline-item :hide-timestamp="true">
            <div class="flex flex-col">
              <header class="text-medium text-theme-black-850 leading-none font-semibold">审批发起人</header>
              <section class="mt-3 box-border flex">
                <div class="p-4 box-border flex items-center w-290px w-auto bg-white rounded-medium shadow-theme">
                  <img class="img-wh rounded-full overflow-hidden" :src="sponsor.assigneePhoto" v-if="sponsor.assigneePhoto" />
                  <div class="img-wh rounded-full bg-theme text-small text-white flex justify-center items-center" v-else>
                    {{thumbName(sponsor.assigneeName || sponsor.createBy)}}
                  </div>
                  <p class="ml-2 flex-1 flex flex-col whitespace-nowrap overflow-hidden">
                    <el-tooltip v-if="isRedPocketAudit || isMessageAudit"  :content="`${sponsor.createBy}-${sponsor.createByTel}`">
                      <span class="text-medium-x text-theme-black-850 leading-22">
                        {{ sponsor.createBy }}-{{ sponsor.createByTel }}
                      </span>
                    </el-tooltip>
                    <el-tooltip v-else  :content="`${sponsor.assigneeName}-${formatAssigneePhone}`">
                      <span class="text-medium-x text-theme-black-850 leading-22">
                        {{ sponsor.assigneeName }}-{{ formatAssigneePhone }}
                      </span>
                    </el-tooltip>
                    <span class="mt-2 text-small text-theme-black-650">发起审批时间：{{ sponsor.createTime }}</span>
                    <el-tooltip :content="(isRedPocketAudit || isMessageAudit) ? '北京清研灵智科技有限公司' : sponsor.companyName">
                      <span class="mt-2 text-small text-theme-black-650 truncate">所属企业：{{ (isRedPocketAudit || isMessageAudit) ? '北京清研灵智科技有限公司' : sponsor.companyName }}</span>
                    </el-tooltip>
                  </p>
                </div>
              </section>
            </div>
          </el-timeline-item>
          <el-timeline-item :hide-timestamp="true">
            <div class="flex flex-col">
              <header class="text-medium text-theme-black-850 leading-none font-semibold">审批明细</header>
              <div class="w-full mt-3 p-4 box-border bg-white rounded-medium shadow-theme">
                <div class="flex items-center">
                  <div class="pr-3 box-border text-medium font-semibold text-theme-black-650" style="max-width: 200px">
                    <el-tooltip :content="approval.settleName">
                      <div class="w-full truncate">{{ approval.settleName }}</div>
                    </el-tooltip>
                  </div>
                  <div
                    class="px-3 box-border text-medium text-theme-black-450 border-l border-solid border-theme-black-250"
                    style="max-width: 175px"
                    v-if="approval.settleNo"
                  >
                    <el-tooltip :content="`项目编号：${approval.settleNo}`">
                      <div class="w-full truncate">{{ approval.settleNo }}</div>
                    </el-tooltip>
                  </div>
                  <div
                    class="px-3 box-border text-medium text-theme-black-450 border-l border-solid border-theme-black-250"
                    style="max-width: 175px"
                    v-if="approval.period && (isRedPocketAudit || isMessageAudit)"
                  >
                    <el-tooltip :content="`隶属时间：${approval.period}`">
                      <div class="w-full truncate">{{ approval.period }}</div>
                    </el-tooltip>
                  </div>
                  <div
                    class="px-3 box-border text-medium text-theme-black-450 border-l border-solid border-theme-black-250"
                    style="max-width: 175px"
                    v-if="approval.departmentName && (isRedPocketAudit || isMessageAudit)"
                  >
                    <el-tooltip :content="`部门名称：${approval.departmentName}`">
                      <div class="w-full truncate">{{ approval.departmentName }}</div>
                    </el-tooltip>
                  </div>
                  <div
                    class="px-3 box-border text-medium text-theme-black-450 border-l border-solid border-theme-black-250"
                    style="max-width: 175px"
                    v-if="approval.settleDept"
                  >
                    <el-tooltip :content="approval.settleDept">
                      <div class="w-full truncate">{{ approval.settleDept }}</div>
                    </el-tooltip>
                  </div>
                  <div
                    class="px-3 box-border text-medium text-theme-black-450 border-l border-solid border-theme-black-250"
                    v-if="soTypeMap[soType]"
                  >
                    {{ `结算${soTypeMap[soType]}` }}
                  </div>
                  <div
                    class="px-3 box-border text-medium text-theme-black-450 border-l border-solid border-theme-black-250"
                    v-if="cardInfoMonth"
                  >
                    {{ cardInfoMonth }}
                  </div>
                  <template v-if="isQY && approval.taskSquareUrl">
                    <div
                      class="px-3 box-border text-medium text-theme-black-450 border-l border-solid border-theme-black-250"
                      v-if="isLinkUrl"
                    >
                      <a
                        class="text-theme text-medium no-underline cursor-pointer select-none"
                        target="_blank"
                        :href="approval.taskSquareUrl"
                        >任务广场链接</a
                      >
                    </div>
                    <div
                      class="px-3 box-border text-medium text-theme-black-450 border-l border-solid border-theme-black-250"
                      v-else
                    >
                      <span class="mr-1">未在任务广场上线</span>
                      <el-popover placement="bottom" width="250" trigger="click" :content="approval.taskSquareUrl">
                        <span class="text-theme text-small cursor-pointer select-none" slot="reference">
                          原因<i class="ml-1 el-icon-question"></i>
                        </span>
                      </el-popover>
                    </div>
                  </template>
                </div>
                <ul class="w-full h-24 flex items-center bg-white overflow-hidden">
                  <li :class="['flex', 'items-center', itemWidth]" v-for="(col, index) of colList" :key="col.prop">
                    <section
                      class="flex-1 flex flex-col overflow-hidden"
                      :class="{
                        'items-center': index > 0 && index < colList.length - 1,
                        'items-start': index === 0,
                        'items-end': index === colList.length - 1
                      }"
                    >
                      <div class="flex-1 flex flex-col overflow-hidden">
                        <p class="flex items-center">
                          <span class="mr-1 text-theme-black-650 leading-22 text-medium">{{ col.label }}</span>
                          <el-tooltip
                            :content="typeof col.tooltip === 'function' ? col.tooltip(accountingRate) : col.tooltip"
                            placement="top-start"
                            v-if="col.isTooltip"
                          >
                            <i class="iconfont icon-shuoming text-theme-black-350 text-medium"></i>
                          </el-tooltip>
                        </p>
                        <div class="my-1 text-large-x font-semibold text-theme-black-850 leading-22">
                          <span v-if="col.price">{{ getPrice(approval[col.prop]) }}</span>
                          <span v-else>{{ approval[col.prop] || (col.text ? '' : 0) }}</span>
                        </div>
                        <p class="text-small leading-none" v-if="col.footerMsg">
                          <template v-if="approval[col.footerMsg.prop] || col.footerMsg.defaultVal">
                            <span
                              class="select-none cursor-pointer"
                              :class="col.footerMsg.colorName"
                              @click="openDetail"
                              v-if="col.footerMsg.click"
                              >{{ approval[col.footerMsg.prop] || col.footerMsg.defaultVal }}</span
                            >
                            <span :class="col.footerMsg.colorName" v-else>
                              {{ approval[col.footerMsg.prop] || col.footerMsg.defaultVal }}
                            </span>
                          </template>
                          <span class="invisible" v-else>人工导入项目</span>
                          <el-tooltip
                            :content="col.footerMsg.tooltip"
                            placement="top-start"
                            v-if="col.footerMsg.isTooltip && col.footerMsg.icon"
                          >
                            <i class="iconfont icon-shuoming text-theme-black-350 ml-1 text-small"></i>
                          </el-tooltip>
                        </p>
                        <div class="invisible h-4" v-else />
                      </div>
                    </section>
                    <div
                      class="w-px h-14 border-l border-solid border-divide-d9 overflow-hidden"
                      v-if="index < colList.length - 1"
                    />
                  </li>
                </ul>
              </div>
              <footer
                class="mt-1 text-small text-yellow-theme leading-18 inline-flex items-center"
                v-if="pay && +soType === soTypeCode.PROXY"
              >
                <i class="mr-1 el-icon-warning-outline text-medium"></i>
                注：请完成线下打款后，再操作“已确认打款”
              </footer>
            </div>
          </el-timeline-item>
          <el-timeline-item :hide-timestamp="true" v-if="pay && +soType === soTypeCode.INVEST">
            <div class="flex flex-col">
              <header class="text-medium text-theme-black-850 leading-none font-semibold">{{ accountHeaderText }}账户金额</header>
              <div class="flex mt-3">
                <div v-for="(item, index) in sendChannels" :key="index" @click="selectChannel(item)" :class="`w-370px p-4 box-border bg-white rounded-medium shadow-theme cursor-pointer ml-3 ${currentSendChannel.sendChannelCode === item.sendChannelCode ? 'border-theme border-solid':''}`" style="border-width:1px;">
                  <div class="text-medium text-theme-black-650 leading-none">{{ payPlatformName }}{{item.sendChannelName}}</div>
                  <div class="my-1 text-large-x text-theme-black-850 leading-22">{{ getPrice(item.balanceYuanAmount) }}</div>
                  <p class="text-small text-danger leading-none" v-if="insBalPlan1(item.balanceYuanAmount)">
                    账户余额不足，
                    <span class="text-theme-black-850">请前往</span>
                    <span class="text-theme select-none cursor-pointer" @click="toPayHandle">
                      {{ payPlatformText }}平台去充值
                    </span>
                  </p>
                  <template v-else-if="insBalPlan2(item.balanceYuanAmount)">
                    <p class="text-small text-danger leading-none" v-if="isAdmin">
                      账户余额不足，
                      <span class="text-theme select-none cursor-pointer" @click="toPayHandle">去充值</span>
                    </p>
                    <p class="text-small text-danger leading-none" v-else>账户余额不足，请联系企业管理员充值</p>
                  </template>
                </div>
              </div>
            </div>
          </el-timeline-item>
          <el-timeline-item :hide-timestamp="true">
            <div class="flex flex-col">
              <header class="text-medium text-theme-black-850 leading-none font-semibold">审批说明</header>
              <div class="w-full mt-3">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入"
                  maxlength="200"
                  v-model="comment"
                  class="bg-white-input"
                />
                <p class="mt-1 text-small text-yellow-theme leading-18 inline-flex items-center">
                  <i class="mr-1 el-icon-warning-outline text-medium"></i>
                  注：驳回必须填写，同意可视情况填写。
                </p>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <template #footer>
        <footer class="flex items-center justify-between" v-if="pay && +soType === soTypeCode.PROXY">
          <el-button
            class="no-plainbtn-theme"
            size="small"
            plain
            :disabled="disabledCommentBtn"
            @click="openSendComment"
          >给发起人评论</el-button>
          <div>
            <el-button
              key="no_pay_btn"
              class="no-plainbtn-theme"
              size="small"
              plain
              :loading="rjConfirmLoading"
              @click="proxyPaymentHandle(false)"
              >驳回</el-button
            >
            <el-button
              key="already_pay_btn"
              size="small"
              type="primary"
              :loading="agConfirmLoading"
              @click="proxyPaymentHandle(true)"
              >已确认打款</el-button
            >
          </div>
        </footer>
        <footer class="flex items-center justify-between" v-else>
          <el-button
            v-if="!isRedPocketAudit && !isMessageAudit"
            class="no-plainbtn-theme"
            size="small"
            plain
            :disabled="disabledCommentBtn"
            @click="openSendComment"
          >给发起人评论</el-button>
          <div v-else></div>
          <div>
            <el-button
              key="reject_btn"
              class="normal-button no-plainbtn-theme"
              size="small"
              plain
              :loading="rjConfirmLoading"
              @click="approvalHandle(false)"
              >驳回</el-button
            >
            <!-- 选择过打款通道再显示按钮 -->
            <template v-if="pay && currentSendChannel.sendChannelName">
              <el-button key="p1_admin_btn" type="primary" size="small" @click="toPayHandle" v-if="isNotEnough && planCategory1">
                账户余额不足，去充值
              </el-button>
              <template v-else-if="isNotEnough && planCategory2">
                <el-button key="p2_admin_btn" type="primary" size="small" @click="toPayHandle" v-if="isAdmin">
                  账户余额不足，去充值
                </el-button>
                <el-button key="p2_no_admin_btn" type="primary" size="small" disabled v-else>
                  账户余额不足，请联系企业管理员充值
                </el-button>
              </template>
              <el-button
                v-if="!isNotEnough"
                key="pass_btn"
                type="primary"
                size="small"
                :loading="agConfirmLoading"
                @click="approvalHandle(true)"
                >确认支付</el-button
              >
            </template>
            <template v-if="pay && !currentSendChannel.sendChannelName">
              <span class="text-danger text-right ml-4"><i class="mr-1 el-icon-warning-outline text-medium"></i>请选择支付账户</span>
            </template>
            <el-button
              v-if="!pay"
              key="pass_btn"
              type="primary"
              size="small"
              :loading="agConfirmLoading"
              @click="approvalHandle(true)"
              >通过</el-button
            >
          </div>
        </footer>
      </template>
    </el-dialog>
    <adjust-detail-drawer ref="detailDrawer" :sid="statementId" />
  </div>
</template>

<script>
import dialogMixins from '@/mixins/dialog'
import { createPopup } from '@/assets/js/factory'
import { toApproval, getApprovalDetail } from '@/api/cost-settlement/myRelate'
import { isTsingyangRelCompany } from '@/api/cost-settlement/settlement-initiate/relateProject'
import GlobalConfig from '@/global/config'
import AdjustDetailDrawer from '@/views/home/cost-settlement/settlement-initiate/settle-process/components/AdjustDetailDrawer'
import CommentDialog from './CommentDialog'
import CommentSuccessDialog from './CommentSuccessDialog'
import { getWjawardSummary, awardOrderAuditNextQy, msgOrderAuditNext } from '@/api/cost-settlement/approve'
import {
  investStatisticsProps,
  proxyStatisticsProps,
  soTypeCode,
  soTypeMap,
  planCategoryCode,
  payPlatform,
  payPlatformCode,
  onlineCode,
  msgAuditProps,
  redpocketAuditProps
} from '../config/cost-sett'

export default {
  name: 'ApprovalDialog',
  mixins: [dialogMixins],
  components: {
    AdjustDetailDrawer
  },
  props: {
    // 发起人的数据
    sponsor: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: [String, Number],
      default: ''
    },
    statementId: {
      type: [String, Number],
      default: ''
    },
    approvalInfo: {
      type: [Object, null],
      default: null
    },
    // companyAccount: {
    //   type: [String, Number],
    //   default: ''
    // },
    pay: {
      type: Boolean,
      default: false
    },
    showDialog: {
      type: Boolean,
      default: true
    },
    soType: {
      type: [String, Number],
      default: ''
    },
    planCategory: {
      type: [String, Number],
      default: ''
    },
    payPlatformCategory: {
      type: [String, Number],
      default: ''
    },
    onApprovalSuccess: {
      type: [Function, null],
      default: null
    },
    onCommentSuccess: {
      type: [Function, null],
      default: null
    },
    onToPay: {
      type: [Function, null],
      default: null
    },
    pageType: { //红包-短信审批参数
      type: Number | String,
      default: null
    },
    sendChannels: {
      type: Array,
      default: ()=>([])
    },
    payPlatformName: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      soTypeCode,
      soTypeMap,
      payPlatform,
      agConfirmLoading: false,
      rjConfirmLoading: false,
      loading: false,
      approval: {
        settleName: '',
        settleDept: '',
        settleNo: '',
        settleMonth: '',
        settleTimeType: '',
        taskSquareUrl: '',
        createTime: '',
        linkedSurveyProjectTotal: 0,
        investigatorsNum: 0,
        expectedYuanAmount: 0,
        serviceYuanAmount: 0,
        operationalYuanAmount: 0,
        linkedImportProjectText: '',
        adjustYuanAmountText: '',
        period: '',
        departmentName: '',
        payType: '',
        redPacketType: '',
        redPacketNum: '',
        expectBonus: ''
      },
      comment: '',
      isQY: false,
      currentSendChannel: {}
    }
  },
  computed: {
    isRedPocketAudit() {
      return this.pageType && this.pageType === soTypeCode.PACKET
    },
    isMessageAudit() {
      return this.pageType && this.pageType === soTypeCode.MESSAGE
    },
    accountingRate() {
      return this.$store.getters.accountingRate
    },
    itemWidth() {
      switch (true) {
        case +this.soType === soTypeCode.INVEST:
          return 'w-1/5'
        case +this.soType === soTypeCode.PROXY:
          return 'w-1/3'
        case this.pageType === soTypeCode.MESSAGE:
        case this.pageType === soTypeCode.PACKET:
          return 'w-1/4'
        default:
          return ''
      }
    },
    colList() {
      switch (true) {
        case +this.soType === soTypeCode.INVEST:
          return investStatisticsProps.filter(f => f.prop !== 'settleObjTypeText')
        case +this.soType === soTypeCode.PROXY:
          return proxyStatisticsProps.filter(f => f.prop !== 'settleObjTypeText')
        case this.pageType === soTypeCode.MESSAGE:
          return msgAuditProps
        case this.pageType === soTypeCode.PACKET:
          return redpocketAuditProps
        default:
          return []
      }
    },
    isAdmin() {
      if (GlobalConfig.getCompanyId() == 0) return false
      return this.$store.getters.userInfo?.isAdmin == 1
    },
    formatAssigneePhone() {
      const phone = this.sponsor.assigneePhone || ''
      return phone.replace(/\B(?=(\d{4})+(?!\d))/g, ' ')
    },
    planCategory1() {
      return this.planCategory === planCategoryCode.PLAN1
    },
    planCategory2() {
      return this.planCategory === planCategoryCode.PLAN2
    },
    insBalPlan1() {
      return function(companyAccount) {
        return +this.approval.expectedYuanAmount > +companyAccount && this.planCategory1
      }
    },
    insBalPlan2() {
      return function(companyAccount) {
        return +this.approval.expectedYuanAmount > +companyAccount && this.planCategory2
      }
    },
    isNotEnough() {
      return +this.approval.expectedYuanAmount > +this.currentSendChannel.balanceYuanAmount
    },
    payPlatformText() {
      return this.payPlatform[this.payPlatformCategory ?? ''] ?? ''
    },
    accountHeaderText() {
      return (
        {
          [planCategoryCode.PLAN1]: '支付',
          [planCategoryCode.PLAN2]: '企业'
        }[this.planCategory ?? ''] ?? ''
      )
    },
    accountText() {
      if (this.planCategory2) return '企业'
      return this.payPlatformText
    },
    cardInfoMonth() {
      if (!this.approval.settleMonth) {
        return ''
      }
      const cmStr = this.approval.settleMonth.split('-')[1]
      if (!cmStr) return ''
      return this.approval.settleTimeType === 'q' ? cmStr : `${+cmStr}月`
    },
    isLinkUrl() {
      return /[a-z,A-Z]/.test(this.approval?.taskSquareUrl?.[0] ?? '')
    },
    disabledCommentBtn() {
      if (this.sponsor.createUserId === undefined) return true;
      const { userId } = this.$store.getters.userInfo || {};
      return userId === this.sponsor.createUserId;
    },
    title() {
      if(this.isRedPocketAudit) {
        return '红包审批'
      }else if(this.isMessageAudit) {
        return '短信审批'
      }else {
        return `确认${this.pay ? '支付' : '审批'}`
      }
    },
    approvalApi() {
      if(this.isRedPocketAudit) {
        return awardOrderAuditNextQy
      }else if(this.isMessageAudit) {
        return msgOrderAuditNext
      }else {
        return toApproval
      }
    }
  },
  mounted() {
    if (this.approvalInfo) {
      this.setDetail()
    } else {
      this.getDetail()
    }
    this.getQYStatus()
  },
  watch: {
    showDialog: {
      handler(bool) {
        this.visible = bool
      },
      immediate: true
    },
    visibility(bool) {
      if (bool) {
        this.getQYStatus()
      } else {
        this.comment = ''
        this.currentSendChannel = {}
      }
      this.$emit('update:showDialog', bool)
    },
    approvalInfo: {
      handler() {
        this.setDetail()
      },
      deep: true
    }
  },
  methods: {
    getPrice(price) {
      return Number.isNaN(+price) ? '0.00' : (+price).toFixed(2)
    },
    thumbName(assigneeName) {
      return (assigneeName || '').slice(-2)
    },
    setDetail() {
      if (this.approvalInfo) {
        const {
          settleName,
          settleDept,
          settleNo,
          settleMonth,
          settleTimeType,
          taskSquareUrl,
          createTime,
          investigatorsNum,
          expectedYuanAmount,
          serviceYuanAmount,
          operationalYuanAmount,
          linkedImportProjectNum,
          linkedInvestigateProjectNum,
          linkedSurveyProjectNum,
          adjustYuanAmount,
          // 红包审批字段
          projectId,
          projectName,
          period,
          departmentName,
          payType,
          redPacketType,
          redPacketNum,
          expectBonus,
          smsPerson,
          smsQuantity,
          smsAmount,
          smsTotalAmount
        } = this.approvalInfo
        this.approval.settleName = settleName ?? ''
        this.approval.settleNo = settleNo ?? ''
        this.approval.settleMonth = settleMonth ?? ''
        this.approval.settleTimeType = settleTimeType ?? ''
        this.approval.settleDept = settleDept ?? ''
        this.approval.taskSquareUrl = taskSquareUrl ?? ''
        this.approval.createTime = createTime ?? ''
        this.approval.investigatorsNum = investigatorsNum ?? 0
        this.approval.expectedYuanAmount = expectedYuanAmount ?? 0
        this.approval.serviceYuanAmount = serviceYuanAmount ?? 0
        this.approval.operationalYuanAmount = operationalYuanAmount ?? 0
        this.approval.linkedSurveyProjectTotal =
          (linkedImportProjectNum ?? 0) + (linkedInvestigateProjectNum ?? 0) + (linkedSurveyProjectNum ?? 0)
        this.approval.linkedImportProjectText = +linkedImportProjectNum ? `含人工导入项目 ${linkedImportProjectNum} 个` : ''
        this.approval.adjustYuanAmountText = +adjustYuanAmount !== 0 ? `含补扣款 ${this.getNumToFixed(adjustYuanAmount)}` : ''
        this.setAdjustAmountTooltipStatus()
        
        if(this.isRedPocketAudit || this.isMessageAudit) {
          this.approval.settleName = projectName ?? ''
          this.approval.settleNo = projectId ?? ''
          this.approval.period = period ?? ''
          this.approval.departmentName = departmentName ?? ''
          this.approval.payType = this.formatPayType(payType) ?? ''
          this.approval.redPacketType = this.formatRedPacketType(redPacketType) ?? ''
          this.approval.redPacketNum = redPacketNum ?? 0
          this.approval.expectBonus = expectBonus ?? 0
          this.approval.smsPerson = smsPerson ?? 0
          this.approval.smsQuantity = smsQuantity ?? 0
          this.approval.smsAmount = smsAmount ?? 0
          this.approval.smsTotalAmount = smsTotalAmount ?? 0

        }
      }
    },
    formatPayType(payType) {
      switch (payType) {
        case 1:
          return '答题红包'
        case 2:
          return '分享红包'
      }
    },
    formatRedPacketType(redPacketType) {
      switch (redPacketType) {
        case 1:
          return '定额红包'
        case 2:
          return '随机金额红包'
        case 3:
          return '随机定额红包'
        case 4:
          return '红包'
        default:
          return '定额红包'
      }
    },
    setAdjustAmountTooltipStatus() {
      if (+adjustYuanAmount === 0) {
        this.adjustAmountTooltipStatus = false
      } else {
        this.adjustAmountTooltipStatus = true
      }
    },
    getDetail() {
      if (this.id) {
        this.loading = true
        const requestApi = this.isRedPocketAudit ? getWjawardSummary : getApprovalDetail
        requestApi(this.id)
          .then(res => {
            const { code, msg } = res?.data || {}
            if (code === 0) {
              const dt = res?.data?.data ?? {}
              this.approval.settleName = dt.settleName ?? ''
              this.approval.settleDept = dt.settleDept ?? ''
              this.approval.settleNo = dt.settleNo ?? ''
              this.approval.settleMonth = dt.settleMonth ?? ''
              this.approval.settleTimeType = dt.settleTimeType ?? ''
              this.approval.taskSquareUrl = dt.taskSquareUrl ?? ''
              this.approval.createTime = dt.createTime ?? ''
              this.approval.investigatorsNum = dt.investigatorsNum ?? 0
              this.approval.expectedYuanAmount = dt.expectedYuanAmount ?? 0
              this.approval.serviceYuanAmount = dt.serviceYuanAmount ?? 0
              this.approval.operationalYuanAmount = dt.operationalYuanAmount ?? 0
              this.approval.linkedSurveyProjectTotal =
                (dt.linkedImportProjectNum ?? 0) + (dt.linkedInvestigateProjectNum ?? 0) + (dt.linkedSurveyProjectNum ?? 0)
              this.approval.linkedImportProjectText = +dt.linkedImportProjectNum
                ? `含人工导入项目 ${dt.linkedImportProjectNum} 个`
                : ''
              this.approval.adjustYuanAmountText =
                +dt.adjustYuanAmount !== 0 ? `含补扣款 ${this.getNumToFixed(dt.adjustYuanAmount)}` : ''
              this.setAdjustAmountTooltipStatus()
            } else {
              this.$message.error(msg ?? '获取审批明细失败')
            }
          })
          .catch(() => {
            this.$message.error('获取审批明细失败')
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    getQYStatus() {
      isTsingyangRelCompany()
        .then(res => {
          const { code, msg, data } = res.data || {}
          if (code === 0) {
            this.isQY = !!data
          } else {
            this.$message.error(msg ?? '获取是否是清研相关企业状态失败')
          }
        })
        .catch(() => {
          this.$message.error('获取是否是清研相关企业状态失败')
        })
    },
    setAdjustAmountTooltipStatus() {
      if (+this.soType === soTypeCode.INVEST) {
        const col = this.colList.find(f => f.prop === 'expectedYuanAmount')
        if (col) {
          col.footerMsg.isTooltip = !!this.approval.adjustYuanAmountText
        }
      } else if (+this.soType === soTypeCode.PROXY) {
        const col = this.colList.find(f => f.prop === 'operationalYuanAmount')
        if (col) {
          col.footerMsg.isTooltip = !!this.approval.adjustYuanAmountText
        }
      }
    },
    getNumToFixed(num) {
      const n = Number.isNaN(+num) ? 0 : +num
      return n === 0 ? '0.00' : n < 0 ? n.toFixed(2) : `+${n.toFixed(2)}`
    },
    approvalHandle(pass) {
      if (this.id) {
        const isTrim = this.comment.trim().length === 0
        if (!pass && isTrim) {
          this.$message.warning('请填写驳回理由')
          return
        }
        let req = {
          taskId: this.id,
          comment: this.comment,
          pass,
          online: onlineCode.ONLINE,
          sendChannelCode: this.currentSendChannel.sendChannelCode,
          sendChannelName: this.currentSendChannel.sendChannelName
        }
        const errMsg = pass ? '提交审批失败' : '驳回审批失败'
        if (pass) {
          this.agConfirmLoading = true
        } else {
          this.rjConfirmLoading = true
        }
        //红包、短信审批提交
        if(this.isRedPocketAudit || this.isMessageAudit){
          req = {
            id: this.id,
            pass,
            auditDescription: this.comment,
          }
        }
        console.log(req,'----')
        // const requestApi = this.isRedPocketAudit ? awardOrderAuditNextQy : toApproval
        this.approvalApi(req)
          .then(res => {
            const { code, msg } = res?.data || {}
            if (code === 0) {
              this.$message.success(pass ? '审批成功' : '驳回成功')
              if(this.isRedPocketAudit || this.isMessageAudit) return
              if (typeof this.onApprovalSuccess === 'function') {
                this.onApprovalSuccess()
              } else {
                this.$emit('approvalSuccess')
              }
            } else {
              this.$message.error(msg || errMsg)
            }
          })
          .catch(() => {
            this.$message.error(errMsg)
          })
          .finally(() => {
            this.visibility = false
            if(this.isRedPocketAudit || this.isMessageAudit){
              if (typeof this.onApprovalSuccess === 'function') {
                this.onApprovalSuccess()
              } else {
                this.$emit('approvalSuccess')
              }
            }
            if (pass) {
              this.agConfirmLoading = false
            } else {
              this.rjConfirmLoading = false
            }
          })
      } else {
        this.$message.warning('无taskId')
      }
    },
    toPayHandle() {
      if (this.planCategory1) {
        if (payPlatformCode.HYG === +this.payPlatformCategory) {
          // 慧用工充值链接
          window.open('https://web.hvyogo.com/')
        } else if (payPlatformCode.LC === +this.payPlatformCategory) {
          // 零才充值链接
          window.open('http://q.lingcaiai.com/')
        } else if (payPlatformCode.HZY === +this.payPlatformCategory) {
          // 华职云场链接
          window.open('https://www.huazhiyunchang.com/')
        } else {
          this.$message.warning('未知的充值地址')
        }
      } else if (this.planCategory2) {
        if (typeof this.onToPay === 'function') {
          this.onToPay()
        } else {
          this.$emit('toPay')
        }
      }
    },
    proxyPaymentHandle(pass) {
      if (this.id) {
        const isTrim = this.comment.trim().length === 0
        if (!pass && isTrim) {
          this.$message.warning('请填写驳回理由')
          return
        }
        const req = {
          taskId: this.id,
          comment: this.comment,
          pass,
          online: onlineCode.ONLINE,
          sendChannelCode: this.currentSendChannel.sendChannelCode,
          sendChannelName: this.currentSendChannel.sendChannelName
        }
        const errMsg = pass ? '确认打款失败' : '驳回失败'
        if (pass) {
          this.agConfirmLoading = true
        } else {
          this.rjConfirmLoading = true
        }
        toApproval(req)
          .then(res => {
            const { code, msg } = res?.data || {}
            if (code === 0) {
              this.$message.success(pass ? '确认打款成功' : '驳回成功')
              this.visibility = false
              if (typeof this.onApprovalSuccess === 'function') {
                this.onApprovalSuccess()
              } else {
                this.$emit('approvalSuccess')
              }
            } else {
              this.$message.error(msg || errMsg)
            }
          })
          .catch(() => {
            this.$message.error(errMsg)
          })
          .finally(() => {
            if (pass) {
              this.agConfirmLoading = false
            } else {
              this.rjConfirmLoading = false
            }
          })
      } else {
        this.$message.warning('无taskId')
      }
    },
    openDetail() {
      this.$refs.detailDrawer.open()
    },
    openSendComment() {
      createPopup(CommentDialog, {
        businessId: this.statementId,
        businessKey: 'Settlement',
        isRefreshEmit: true,
        onSuccess: this.commentSuccessHandle,
      }, {
        store: this.$store
      })
    },
    commentSuccessHandle() {
      if (typeof this.onCommentSuccess === 'function') {
        this.onCommentSuccess()
      }
      createPopup(CommentSuccessDialog, {})
    },
    selectChannel(item) {
      this.currentSendChannel = item
    }
  }
}
</script>

<style lang="scss" scoped>
.max-h-650px {
  max-height: 625px;
}
.img-wh {
  @apply w-10 h-10;
  min-width: 40px;
}
.step_container {
  ::v-deep .el-timeline-item {
    .el-timeline-item__tail {
      left: 3px;
      @apply border-l border-solid border-theme;
    }
    .el-timeline-item__node {
      @apply bg-theme;
    }
    .el-timeline-item__node--normal {
      width: 9px;
      height: 9px;
    }
    .el-timeline-item__wrapper {
      @apply pl-4;
    }
    &:last-child {
      @apply pb-0;
    }
  }
  .w-auto {
    width: auto;
  }
  .w-370px {
    width: 370px;
  }
}
</style>
